'use strict'

// this is hack to work around the @gsm/logger dependency of @gsm/authorizer
module.exports = {
    error() { },
    warning() { },
    info() { },
    verbose() { },
    debug() { },
    silly() { }
}


//////////////////
// WEBPACK FOOTER
// ./mock-logger/index.js
// module id = 76
// module chunks = 51